import { z } from 'zod';

/**
 * Warengruppe (Modul engineering, ADR 0031): 4-stelliger Code — der erste Block
 * der Zeichnungs-/Artikelnummer (`XXXX.YYYYY[.ZZZ]`). `mainGroupCode` ist eine
 * Soft-Ref (§5) auf die inventory-Hauptwarengruppe.
 */
export const commodityGroupCodeSchema = z.number().int().min(1000).max(9999);

export const createCommodityGroupSchema = z.object({
  code: commodityGroupCodeSchema,
  name: z.string().trim().min(1).max(160),
  mainGroupCode: z.number().int().min(1000).max(9999).nullable().optional(),
  isActive: z.boolean().optional(),
});
export type CreateCommodityGroupInput = z.infer<typeof createCommodityGroupSchema>;

export const updateCommodityGroupSchema = createCommodityGroupSchema.partial();
export type UpdateCommodityGroupInput = z.infer<typeof updateCommodityGroupSchema>;

export const commodityGroupResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  code: z.number().int(),
  name: z.string(),
  mainGroupCode: z.number().int().nullable(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  /** Archiviert (Soft-Delete, §7): null = aktiv, sonst Zeitpunkt der Archivierung. */
  deletedAt: z.string().datetime().nullable(),
});
export type CommodityGroupResponse = z.infer<typeof commodityGroupResponseSchema>;

/**
 * Listen-Query (§8): standardmäßig blendet die Liste archivierte Warengruppen
 * aus — mit `includeArchived=true` erscheinen sie zusätzlich (analog Projekte).
 * Ein Code bleibt nach dem Löschen dauerhaft reserviert (DB-Unique-Constraint
 * zählt auch archivierte Zeilen, wie Artikelnummern/ADR 0048) — daher die
 * Reaktivieren-Funktion statt Neuanlage mit demselben Code.
 */
export const commodityGroupListQuerySchema = z.object({
  includeArchived: z.enum(['true', 'false']).optional(),
});
export type CommodityGroupListQuery = z.infer<typeof commodityGroupListQuerySchema>;
